"use client";
//? Library Imports ------------------------------------------------------------>
import { useDispatch } from "react-redux";
import { useState, useEffect, useCallback } from "react";
import { Col, Row, Tag, Space, Skeleton, Typography } from "antd";
import Cookies from "js-cookie";

//? Assets --------------------------------------------------------------------->
import { ArrowLeftOutlined } from "@ant-design/icons";

//? Modules -------------------------------------------------------------------->
import AccountStatus from "@/functions/Cookies/Cookies";
import DynamicButton from "@/components/shared/Buttons/DynamicButton/DynamicButton";
import { customerLogout } from "@/functions/Cookies/Cookies";

//? Redux Reducers ------------------------------------------------------------->
import { logoutReducer } from "@/redux/Slices/accountSlice";
//? Library Constants ---------------------------------------------------------->
const { Text } = Typography;

export default function RewardPoints({ setActiveMenu }) {
  const { comverse_customer_token } = AccountStatus();
  const cookiesCurrency = Cookies.get("defaultCurrencyName");

  //? Redux States --------------------------------------------------------------->

  const dispatch = useDispatch();
  const defaultCurrency = cookiesCurrency;

  const [Loading, setLoading] = useState(true);
  const [RewardPoints, setRewardPoints] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [RewardHistory, setRewardHistory] = useState({});

  const fetchRewardPoints = useCallback(async () => {
    if (comverse_customer_token) {
      try {
        const payload = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: comverse_customer_token,
          },
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND + `/storefront/get_loyalty_cards`,
          payload
        );

        const RewardPoints = await res.json();

        if (!res.ok) {
          if (RewardPoints?.detail === "Invalid auth token") {
            customerLogout();
            dispatch(logoutReducer());
          }
          //logout here
          throw new Error("Reward Points Api Failed!");
        }

        setRewardPoints(RewardPoints);

        if (RewardPoints) {
          setLoading(false);
        }

        return RewardPoints;
      } catch (error) {
        console.error("Reward Points Api Failed!", error);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        return null;
      }
    }
  }, [comverse_customer_token]);

  const fetchRewardHistory = useCallback(async (pNo) => {
    if (comverse_customer_token) {
      try {
        const payload = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: comverse_customer_token,
          },
        };

        const res = await fetch(
          process.env.NEXT_PUBLIC_BACKEND + `/storefront/get_loyalty_history?page=${pNo}`,
          payload
        );

        if (!res.ok) {
          throw new Error("Reward Points Api Failed!");
        }

        const RewardHistory = await res.json();
        setRewardHistory(RewardHistory);

        if (RewardHistory) {
          setLoading(false);
        }

        return RewardHistory;
      } catch (error) {
        console.error("Reward Points Api Failed!", error);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        return null;
      }
    }
  }, [comverse_customer_token]);


  const fetchMoreOrders = async () => {
    const previousResults = RewardHistory?.results;
    const data = await fetchRewardHistory(pageNo + 1);
    setPageNo(pageNo + 1);
    const newResults = data?.results;
    [].push.apply(previousResults, newResults);
    setRewardHistory(prevObject => ({
      ...prevObject,
      results: [...previousResults]
    }));

  }

  useEffect(() => {
    fetchRewardPoints();
  }, [fetchRewardPoints]);

  useEffect(() => {
    fetchRewardHistory(pageNo);
  }, [fetchRewardHistory]);

  return (
    <Skeleton loading={Loading}>
      <Col className="RewardPoints padding20">
        <Space size="middle">
          <Col
            className="flexCenter cursorPointer"
            onClick={() => setActiveMenu("dashboard")}
            style={{ background: "#FFFFFF", width: "29px", height: "30px" }}
          >
            <ArrowLeftOutlined />
          </Col>
          <Text className="font18">Reward Point</Text>
        </Space>

        <Col className="marginTop15">
          <Row className="gap10">
            <Col span={24}>
              <Row className="gap15">
                <Col flex="0 0 auto" className="rewardCard" style={{height: "auto"}}>
                  <Space direction="vertical">
                    <Text className="font18">Earned</Text>
                    <Text style={{ fontSize: "26px" }}>
                      {RewardPoints?.earned} PKR
                      {/* {defaultCurrency} */}
                    </Text>
                  </Space>
                </Col>
                <Col
                  flex="0 0 auto"
                  className="rewardCard"
                  style={{
                    border: "1px solid #000000",
                    boxShadow: "0px 1px 10px #00000080",
                    background: "#FFFFFF 0% 0% no-repeat padding-box",
                    height: "auto",
                  }}
                >
                  <Space direction="vertical">
                    <Text className="font18">Redeemed</Text>
                    <Text style={{ fontSize: "26px" }}>
                      {RewardPoints?.redeemed} PKR
                      {/* {defaultCurrency} */}
                    </Text>
                  </Space>
                </Col>
                <Col
                  flex="0 0 auto"
                  className="rewardCard"
                  style={{
                    border: "1px solid #2A1E5C",
                    boxShadow: "0px 1px 10px #9981FF80",
                    background: "#FFFFFF 0% 0% no-repeat padding-box",
                    height: "auto",
                  }}
                >
                  <Space direction="vertical">
                    <Text className="font18">Available</Text>
                    <Text style={{ fontSize: "26px" }}>
                      {RewardPoints?.available} PKR
                      {/* {defaultCurrency} */}
                    </Text>
                  </Space>
                </Col>
                <Col
                  flex="0 0 auto"
                  className="rewardCard"
                  style={{
                    border: "1px solid #FDB813",
                    boxShadow: "0px 1px 10px #FFFF8180",
                    background: "#FFFFFF 0% 0% no-repeat padding-box",
                    height: "auto",
                  }}
                >
                  <Space direction="vertical">
                    <Text className="font18">Pending</Text>
                    <Text style={{ fontSize: "26px" }}>
                      {RewardPoints?.pending} PKR
                      {/* {defaultCurrency} */}
                    </Text>
                  </Space>
                </Col>
              </Row>
            </Col>

            {RewardHistory?.results?.length > 0 && (
              <Col
                span={24}
                className="RewardTable marginTop30 padding20 backgroundLight"
              >
                <Row>
                  <Col flex="25%" className="font18Bold poppinsMedium">
                    Order No
                  </Col>
                  <Col
                    flex="25%"
                    className="font18Bold poppinsMedium paddingLeft20"
                  >
                    SKU
                  </Col>
                  <Col flex="25%" className="font18Bold poppinsMedium">
                    Reward Points
                  </Col>
                  <Col flex="25%" className="font18Bold poppinsMedium">
                    Order Date
                  </Col>
                </Row>

                <Col span={24} className="marginTop10">
                  {RewardHistory?.results?.map((record, index) => {
                    return (
                      <Row
                        key={index}
                        className={
                          index % 2 === 0 ? "tableRow rowColor" : "tableRow"
                        }
                      >
                        <Col flex="25%" className="alignCenter">
                          {record?.order_name ? record?.order_name : "N/A"}
                        </Col>
                        <Col flex="25%" className="alignCenter paddingLeft20">
                          {record?.sku ? record?.sku : "N/A"}
                        </Col>
                        <Col flex="25%" className="alignCenter">
                          {record?.points ? (record?.points > 0 ? `+${record?.points}` : record?.points) : 0} Pt
                          <>
                            {
                              record?.status === "pending" &&
                              <Tag className="ptsTag" style={{ backgroundColor: "#fdb813" }}>
                                {record?.status ? record?.status : "N/A"}
                              </Tag>
                            }
                            {
                              record?.status === "earned" &&
                              <Tag className="ptsTag" style={{ backgroundColor: "green" }}>
                                {record?.status ? record?.status : "N/A"}
                              </Tag>
                            }
                            {
                              record?.status === "cancelled" &&
                              <Tag className="ptsTag" style={{ backgroundColor: "red" }}>
                                {record?.status ? record?.status : "N/A"}
                              </Tag>
                            }
                            {
                              record?.status === "redeemed" &&
                              <Tag className="ptsTag" style={{ backgroundColor: "black" }}>
                                {record?.status ? record?.status : "N/A"}
                              </Tag>
                            }
                            {
                              record?.status === "reverted" &&
                              <Tag className="ptsTag" style={{ backgroundColor: "red" }}>
                                {record?.status ? record?.status : "N/A"}
                              </Tag>
                            }
                          </>
                        </Col>
                        <Col flex="25%" className="alignCenter">
                          {record?.created_at ? record?.created_at : "N/A"}
                        </Col>
                      </Row>
                    );
                  })}

                  {RewardHistory?.next && (
                    <DynamicButton
                      type="primary"
                      name="Load More"
                      property="danger"
                      className="primary_btn_outline loadMore"
                      function={() => fetchMoreOrders()}
                    />
                  )}
                </Col>
              </Col>
            )}
          </Row>
        </Col>
      </Col>
    </Skeleton>
  );
}
